import { FC, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { PageErrorMessage } from '@ebsco-ui/ebsco-ui';

import {
  AppReady,
  AppSetup,
  FeatureFlagsProvider,
  Image,
  LocalizationProvider,
  NotFoundImage,
} from '@app/components';
import { FeatureFlag } from '@app/contexts';

export interface InitialAppState {
  featureFlags: FeatureFlag[];
  pageBannerMessage: string;
  isGuestUserLoggedIn: boolean;
}

export const App: FC = () => {
  const [isOkapiSessionDown, setIsOkapiSessionDown] = useState(false);
  const [initialAppState, setInitialAppState] = useState<InitialAppState>();

  if (isOkapiSessionDown) {
    return (
      <LocalizationProvider>
        <PageErrorMessage
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          title={
            <FormattedMessage
              tagName="div"
              id="serverIsDown"
              defaultMessage="Server is down"
            />
          }
          titleTag="h1"
          image={<Image src={NotFoundImage} alt="404" />}
          imagePlacement="block-end"
          className="container serverIsDown"
        />
      </LocalizationProvider>
    );
  }

  return !initialAppState?.isGuestUserLoggedIn ? (
    <AppSetup
      setInitialAppState={setInitialAppState}
      setIsOkapiSessionDown={setIsOkapiSessionDown}
    />
  ) : (
    <LocalizationProvider>
      <FeatureFlagsProvider flags={initialAppState.featureFlags}>
        <AppReady
          bannerMessage={initialAppState.pageBannerMessage}
          setIsOkapiSessionDown={setIsOkapiSessionDown}
        />
      </FeatureFlagsProvider>
    </LocalizationProvider>
  );
};
